import React, { useState } from 'react';
import { Button, Popover } from 'antd';
import { PlusIcon } from 'lucide-react';
import AddClientModalGlobally from './AddClientModalGlobally';
import AddOrderModalGlobally from './AddOrderModalGlobally';
import usePermissions from '../../hooks/usePermissions';

const formOptions = [
    { key: 'client', label: 'Create Client', permission: 'can_create_client', color: '#000' },
    { key: 'order', label: 'Create Order', permission: 'can_create_task', color: '#36c6d3' },
];

const GloballyForms = () => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isClientModalVisible, setIsClientModalVisible] = useState(false);
    const [isOrderModalVisible, setIsOrderModalVisible] = useState(false);
    const [modalKey, setModalKey] = useState(0);
    const { hasPermission } = usePermissions()

    const handleMenuClick = (key) => {
        setPopoverVisible(false);
        if (key === 'client') {
            setIsClientModalVisible(true);
            setModalKey((prevKey) => prevKey + 1);
        }
        else if (key === 'order') {
            setIsOrderModalVisible(true);
            setModalKey((prevKey) => prevKey + 1);
        }
    };

    const hexToRgba = (hex, alpha) => {
        let r = 0, g = 0, b = 0;

        if (hex.length === 4) {
            r = "0x" + hex[1] + hex[1];
            g = "0x" + hex[2] + hex[2];
            b = "0x" + hex[3] + hex[3];
        } else if (hex.length === 7) {
            r = "0x" + hex[1] + hex[2];
            g = "0x" + hex[3] + hex[4];
            b = "0x" + hex[5] + hex[6];
        }

        return `rgba(${+r},${+g},${+b},${alpha})`;
    }

    const popoverContent = (
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 140 }}>
            {formOptions
                .filter(({ permission }) => hasPermission(permission))
                .map(({ key, label, color }) => (
                    <span
                        key={key}
                        onClick={() => handleMenuClick(key)}
                        style={{
                            padding: '8px',
                            cursor: 'pointer',
                            borderRadius: 4,
                            transition: 'all 0.3s ease',
                            color: color,
                            letterSpacing: "0.5px",
                        }}
                        onMouseEnter={(e) => {
                            const rgbaColor = hexToRgba(color, 0.15);
                            e.target.style.background = rgbaColor;
                            e.target.style.color = color;
                            e.target.style.fontWeight = 'bold';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = 'transparent';
                            e.target.style.color = color;
                            e.target.style.fontWeight = 'normal';
                        }}
                    >
                        {label}
                    </span>
                ))}
        </div>

    );

    return (
        <>
            <Popover
                content={popoverContent}
                trigger="click"
                visible={popoverVisible}
                onVisibleChange={(visible) => setPopoverVisible(visible)}
                placement="bottom"
                overlayInnerStyle={{ padding: 6 }}
            >
                {(hasPermission('can_create_client') || hasPermission('can_create_task')) ? <Button
                    style={{
                        width: 35,
                        height: 35,
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 8,
                        backgroundColor: '#36c6d3',
                        border: '1px solid #d9d9d9',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        transition: 'all 0.3s ease',
                        marginRight: 16,
                        marginLeft: "-10px"
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#000000';
                        e.currentTarget.style.borderColor = '#000000';
                        e.currentTarget.querySelector('svg').style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#36c6d3';
                        e.currentTarget.style.borderColor = '#36c6d3';
                        e.currentTarget.querySelector('svg').style.color = '#fff';
                    }}
                >
                    <PlusIcon size={20} color="#fff" />
                </Button> : null}
            </Popover>
            <AddClientModalGlobally
                key={modalKey}
                visible={isClientModalVisible}
                onClose={() => setIsClientModalVisible(false)}
            />
            <AddOrderModalGlobally
                key={modalKey}
                visible={isOrderModalVisible}
                onClose={() => setIsOrderModalVisible(false)}
                setIsOrderModalVisible={setIsOrderModalVisible}
            />
        </>
    );
};

export default GloballyForms;
